<template>
  <model-form
    ref="modelForm"
    :model="itemClass"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <model-form-input
          field="name"
          class="col-6"
          label="Name"
          :autofocus="!$q.platform.is.ios"
          :rules="[val => !!val || 'Field is required']"
        />
        <div class="col-6">
          <color-picker
            color-name="custom"
            :color-hex="itemClass.color"
            :disable="itemClass.isTranslation"
            @update:model-value="value => itemClass.color = value"
          />
        </div>
        <model-form-input
          field="description"
          class="col-12"
          label="Description"
        />
        <q-checkbox
          v-model="itemClass.includeInPerCap"
          class="col-12"
          label="Include In Per Cap"
        />
        <model-form-select
          field="taxIds"
          class="col-12"
          label="Taxes"
          :options="taxes.data"
          option-label="name"
          option-value="id"
          map-options
          emit-value
          multiple
          use-chips
          clearable
        />
        <model-form-input
          v-if="currentSite.polarisEnabled"
          field="polarisDataStreamId"
          class="col"
          label="Polaris Data Stream ID"
        />
      </div>
    </div>
  </model-form>
</template>

<script>
import ColorPicker from 'src/modules/admin/components/ColorPicker'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'ItemClassForm',
  components: {
    ColorPicker,
    ModelForm
  },
  configuration: ['currentSite', 'taxes'],
  models: {
    itemClass: {
      taxes: {
        fields: ['id']
      },
      polarisDataStreamId: true
    }
  }
}

</script>
